import api from "./api-config";
import { CaseNotesDTO } from "../models/CaseNotes";

export const caseNotesService = {
  getAllCaseNotes: async (
    params: {
      "id.greaterThan"?: number;
      "id.lessThan"?: number;
      "id.greaterThanOrEqual"?: number;
      "id.lessThanOrEqual"?: number;
      "id.equals"?: number;
      "id.notEquals"?: number;
      "id.specified"?: boolean;
      "id.in"?: number[];
      "id.notIn"?: number[];
      "noteContent.contains"?: string;
      "noteContent.doesNotContain"?: string;
      "noteContent.equals"?: string;
      "noteContent.notEquals"?: string;
      "noteContent.specified"?: boolean;
      "noteContent.in"?: string[];
      "noteContent.notIn"?: string[];
      "createdAt.greaterThan"?: string;
      "createdAt.lessThan"?: string;
      "createdAt.greaterThanOrEqual"?: string;
      "createdAt.lessThanOrEqual"?: string;
      "createdAt.equals"?: string;
      "createdAt.notEquals"?: string;
      "createdAt.specified"?: boolean;
      "createdAt.in"?: string[];
      "createdAt.notIn"?: string[];
      "readAt.greaterThan"?: string;
      "readAt.lessThan"?: string;
      "readAt.greaterThanOrEqual"?: string;
      "readAt.lessThanOrEqual"?: string;
      "readAt.equals"?: string;
      "readAt.notEquals"?: string;
      "readAt.specified"?: boolean;
      "readAt.in"?: string[];
      "readAt.notIn"?: string[];
      "caseDetailId.greaterThan"?: number;
      "caseDetailId.lessThan"?: number;
      "caseDetailId.greaterThanOrEqual"?: number;
      "caseDetailId.lessThanOrEqual"?: number;
      "caseDetailId.equals"?: number;
      "caseDetailId.notEquals"?: number;
      "caseDetailId.specified"?: boolean;
      "caseDetailId.in"?: number[];
      "caseDetailId.notIn"?: number[];
      "doctorId.greaterThan"?: number;
      "doctorId.lessThan"?: number;
      "doctorId.greaterThanOrEqual"?: number;
      "doctorId.lessThanOrEqual"?: number;
      "doctorId.equals"?: number;
      "doctorId.notEquals"?: number;
      "doctorId.specified"?: boolean;
      "doctorId.in"?: number[];
      "doctorId.notIn"?: number[];
      distinct?: boolean;
      page?: number;
      size?: number;
      sort?: string[];
    } = {}
  ) => {
    const response = await api.get<CaseNotesDTO[]>("/case-notes", {
      params: {
        ...params,
        sort: params.sort?.join(","),
      },
    });
    return response.data;
  },

  getCaseNoteById: async (id: number) => {
    const response = await api.get<CaseNotesDTO>(`/case-notes/${id}`);
    return response.data;
  },

  createCaseNote: async (noteData: CaseNotesDTO) => {
    const response = await api.post<CaseNotesDTO>("/case-notes", noteData);
    return response.data;
  },

  updateCaseNote: async (id: number, noteData: CaseNotesDTO) => {
    const response = await api.put<CaseNotesDTO>(`/case-notes/${id}`, noteData);
    return response.data;
  },

  deleteCaseNote: async (id: number) => {
    await api.delete(`/case-notes/${id}`);
  },

  partialUpdateCaseNote: async (
    id: number,
    noteData: Partial<CaseNotesDTO>
  ) => {
    const response = await api.patch<CaseNotesDTO>(
      `/case-notes/${id}`,
      noteData
    );
    return response.data;
  },

  markAsRead: async (id: number) => {
    const response = await api.put<CaseNotesDTO>(
      `/case-notes/${id}/markAsRead`
    );
    return response.data;
  },

  caseNoteNotRead: async () => {
    const response = await api.get<CaseNotesDTO[]>(
      `/case-notes/caseNoteNotRead`
    );
    return response.data;
  },
};
